import CultivoMaleza from 'components/CultivoMaleza2'

export default CultivoMaleza
